import type { AnySerializationAdapter } from '@tanstack/router-core'

export const pluginSerializationAdapters: Array<AnySerializationAdapter> = []
export const hasPluginAdapters = false
